import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useApiTranslations} from '../../../../context/ApiTranslationsContext';

export type Props = {
  createLicensePlan: (subscriptionType: string) => Promise<void>
  isDrawerOpen: boolean
  onDrawerClosed: () => void
}

export type CreateOrganizationLicensePlanState = {
  selectedSubscriptionType: string | null,
  setSelectedSubscriptionType: (value: string | null) => void

  closeDrawer: () => void
  handleSubmit: () => Promise<void>
  saveButtonDisabled: boolean

  translateLocal: (key: string) => string
  translate: (key: string) => string
}

export const useCreateOrganizationLicensePlanState = (props: Props): CreateOrganizationLicensePlanState => {
  const {t} = useTranslation()
  const {translate: apiTranslate} = useApiTranslations()
  const [selectedSubscriptionType, setSelectedSubscriptionType] = useState<string | null>(null);

  const closeDrawer = () => {
    setSelectedSubscriptionType(null);
    props.onDrawerClosed();
  }

  const handleSubmit = async () => {
    await props.createLicensePlan(selectedSubscriptionType as string)
    closeDrawer()
  }

  return {
    translate: (key) => apiTranslate(key) || t(key),
    translateLocal: (key) => t(`organizations-details.create-organization-license-plan-drawer.${key}`),
    selectedSubscriptionType: selectedSubscriptionType,
    setSelectedSubscriptionType: setSelectedSubscriptionType,
    closeDrawer: closeDrawer,
    handleSubmit: handleSubmit,
    saveButtonDisabled: selectedSubscriptionType === null || selectedSubscriptionType === ''
  }
}
